import {
    useDraggable,
    useDroppable
} from "@dnd-kit/core";

function bgPosForPiece(i) {
    const row = Math.floor(i / 2),
        col = i % 2;
    return `${col * 100}% ${row * 100}%`;
}


function Tile({ id, imgUrl, pieceIndex }) {
    const { setNodeRef: setDropRef, isOver } = useDroppable({ id });
    const {
        attributes,
        listeners,
        setNodeRef: setDragRef,
        transform,
        isDragging,
    } = useDraggable({ id });

    const cls = ["tile", `slot-${id}`, isDragging ? "dragging" : ""].join(" ");

    return (
        <div
            ref={(n) => {
                setDropRef(n);
                setDragRef(n);
            }}
            {...listeners}
            {...attributes}
            className={cls}
            style={{
                backgroundImage: `url(${imgUrl})`,
                backgroundPosition: bgPosForPiece(pieceIndex),
                transform: transform ? `translate3d(${transform.x}px, ${transform.y}px, 0)` : undefined,
                borderColor: isOver ? "#6366f1" : "transparent",
            }}
        />
    );
}

export default Tile